import Vue from 'vue';
import VueRouter from 'vue-router';
import Vuelidate from 'vuelidate';
import VueHotkey from 'v-hotkey';
import { sync } from 'vuex-router-sync';

import App from './App';
import routes from './routes';
import createStore from './store/store';

Vue.use(VueRouter);
Vue.use(Vuelidate);
Vue.use(VueHotkey);

export function createRouter() {
  const router = new VueRouter({
    mode: 'history',
    routes,
    scrollBehavior(to, from, savedPosition) {
      if (savedPosition) {
        return savedPosition;
      }
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve({ x: 0, y: 0 });
        }, 300);
      });
    },
  });
  return router;
}

export function createApp() {
  const router = createRouter();
  const store = createStore();
  sync(store, router);

  const app = new Vue({
    router,
    store, // eslint-disable-next-line
    render: (h) => h(App),
  });

  return { app, router, store };
}



// WEBPACK FOOTER //
// ./src/entry.js